













import {
  getOverview
} from "@/services/inspect.service";

export default  {
  mounted() {
    this.$store.state.headerTitle = "8.2 Inspect Tools"

    getOverview(this.$store.state.cl_uid)
      .then(resp => {
        if (resp.status == "success") {
        }
      })
      .catch(e => {
        this.$store.dispatch("api_error", e);
      });


  }
}

